/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useContext, useEffect, useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router-dom';
import { useRecoilState, useSetRecoilState } from 'recoil';
import LoadingOverlay from 'react-loading-overlay';
import { Grid } from '@material-ui/core';
import AuthenticatedContext from '../../context/AuthenticatedContext';
import { backPageFlg, pageTitle } from '../../context/PageRecoil';
import { pathnames } from '../../api';
import { requestDeviceDetail } from '../../api/device';
import useStyles from '../../css/style';
import { OneEquipment } from '../../models/data/Equipment';
import { requestOneEquipment } from '../../api/equipment';
import { routeName } from '../../App';
import { DeviceDetail } from '../../models/data/Device';
import DataDisp from './datadisp';
import { useErrorHandling } from '../errorCheck';

type UserPageParams = {
  eqid: string;
  id: string;
};

/**
 * 機器点検等メニュー画面
 */
const DeviceMaintMenu: React.FunctionComponent = () => {
  const history = useHistory();
  const authContext = useContext(AuthenticatedContext); // ログインユーザの情報を取得
  const classes = useStyles();
  const [loading, setLoading] = useState(true); // ロード画面の状態管理
  const { eqid, id } = useParams<UserPageParams>();
  const [backFlg, setBackFlg] = useRecoilState(backPageFlg);
  const [data, setData] = useState<OneEquipment>(); // 表示するメインデータ
  const [subdata, setSubData] = useState<DeviceDetail>();
  const { errorCheck } = useErrorHandling(); // エラー処理

  const setPageTitle = useSetRecoilState(pageTitle);
  React.useEffect(() => {
    return setPageTitle({ pageTitle: '機器点検等メニュー' }); // ページのタイトルを設定
  }, [setPageTitle]);

  // APIのURL
  const urlOneEquipment = history.createHref({
    pathname: pathnames.oneEquipment,
  }); // 設備情報取得URL
  const urlDeviceDetail = history.createHref({
    pathname: pathnames.deviceDetail,
  }); // 機器情報取得URL

  // 初回画面表示時の処理
  useEffect(() => {
    setLoading(true); // 非同期処理前にsetLoading(true)
    Promise.all([
      requestOneEquipment(urlOneEquipment, {
        equipmentId: Number(eqid),
      }),
      requestDeviceDetail(urlDeviceDetail, {
        custEqId: Number(eqid),
        mstId: Number(id),
      }),
    ])
      .then((responses) => {
        setData(responses[0].data); // 設備情報
        setSubData(responses[1].data); // 機器情報
      })
      .catch((error) => {
        errorCheck(error); // エラー内容を確認
      })
      .finally(() => {
        setLoading(false); // 非同期処理後にsetLoading(false)
      });
  }, []);

  return (
    <LoadingOverlay
      active={loading}
      className={classes.load}
      spinner
      text="データを読み込んでいます..."
    >
      <div className={classes.root}>
        <Button
          variant="primary"
          className="my-2"
          onClick={() => {
            setBackFlg({ ...backFlg, deviceList: true });
            history.push(`${routeName.deviceList}/${eqid}`);
          }}
        >
          戻る
        </Button>
        <br />
        <DataDisp userdata={authContext} data={data} data2={subdata} />
        <div className={classes.gridWidth2}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Card className={classes.buttonCard}>
                <Card.Header style={{ fontSize: '1rem' }}>一覧</Card.Header>
                <Card.Body className={classes.cardBody}>
                  <Button
                    variant="primary"
                    className={`my-2 mx-2 ${classes.menuButton}`}
                    onClick={() => {
                      history.push(
                        `${routeName.deviceMaintItem}/${eqid}/${id}`,
                      );
                    }}
                  >
                    機器点検
                    <br />
                    項目一覧
                  </Button>
                </Card.Body>
              </Card>
            </Grid>
            <Grid item xs={6}>
              <Card className={classes.buttonCard}>
                <Card.Header style={{ fontSize: '1rem' }}>履歴</Card.Header>
                <Card.Body className={classes.cardBody}>
                  <Button
                    variant="primary"
                    className={`my-2 mx-2 ${classes.menuButton}`}
                    onClick={() => {
                      history.push(
                        `${routeName.deviceMaintList}/${eqid}/${id}`,
                      );
                    }}
                  >
                    機器点検
                  </Button>
                  <Button
                    variant="primary"
                    className={`my-2 mx-2 ${classes.menuButton}`}
                    onClick={() => {
                      history.push(
                        `${routeName.deviceTroubleList}/${eqid}/${id}`,
                      );
                    }}
                  >
                    機器故障修理
                  </Button>
                </Card.Body>
              </Card>
            </Grid>
          </Grid>
        </div>
      </div>
    </LoadingOverlay>
  );
};

export default DeviceMaintMenu;
